<template>
  <div class="grid-view">
    <div class="main-content">
      <!-- 231502: 我的客户 231505: 本组客户 231508: 客户公海-->
      <search-item
        config-module="231508"
        :reset="true"
        :custom-sim-query-placeholder="$t('CargoMsg.Cargo_CustomerQuickSearch')"
        :custom-search-items="customSearchItems"
        no="1"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
      >
        <div slot="operations">
          <!--查看-->
          <el-button :disabled="!selectedJob || total <= 0" type="success" no="2" @click="toLook()">{{ $t('common.btn.look') }}</el-button>
          <!--分配-->
          <el-button v-show="$checkPermission(['role_CRMShareCustomerManager_sign'])" type="primary" no="3" @click="assignHandler()">{{ $t('CargoMsg.Cargo_Distribution') }}</el-button>
          <!--分配给我-->
          <el-button type="primary" no="4" @click="assignMyHandler()">{{ $t('CargoMsg.Cargo_AssignToMe') }}</el-button>
          <!--删除-->
          <el-button v-show="$checkPermission(['role_CRMShareCustomerManager_delete'])" type="danger" no="5" @click="deleteHandler()">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
          <!--直接分配-->
          <el-button v-show="$checkPermission(['role_CRMShareCustomerManager_assignDirect'])" type="primary" no="6" @click="directAssignHandler()">{{ $t('CargoMsg.Cargo_DirectAssign') }}</el-button>
        </div>
      </search-item>
      <div class="section grid-wrapper" style="min-height:350px">
        <cargo-ag-grid
          config-module="23150800"
          :grid-options="gridOptions"
          :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
          :column-defs="columnDefs"
          :row-data="rowData"
          :grid-params.sync="gridParams"
          :check-main-record="false"
          :deselect-main-record="false"
          style="width: 100%;"
          no="7"
          @gridReady="onGridReady"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="23150801"
          :total="total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          no="8"
          @pagination="toQuery()"
        />
      </div>
    </div>

    <!-- 分配 -->
    <el-dialog
      v-if="customerAssignWindow.visible"
      v-el-drag-dialog
      :visible.sync="customerAssignWindow.visible"
      :title="$t('CargoMsg.Cargo_Distribution')"
      width="360px"
      no="9"
      :close-on-click-modal="false"
    >
      <el-form label-width="85px" label-position="left">
        <el-form-item :label="$t('Payment.sales')">
          <cargo-user-select
            :method-params="{category:'role',shape:'sales'}"
            :default-value="customerAssignWindow.sales||''"
            style="width: 230px;"
            no="10"
            @change="p=>{customerAssignWindow.sales=p.value||0}"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" no="11" @click="enterAssignHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="12" @click="customerAssignWindow.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import CargoGridShowBigContent from '@/components/Cargo/grid/cargoGridShowBigContent'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { ensureExecuteSuccess } from '@/utils/commonUtil'
import { queryQuotationClientPageable, assignQuotationClients, assignQuotationClientsAndApprove } from '@/api/sales/quotationClient'
import { checkDeleteCustomer, deleteCustomer } from '@/api/company'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnTagRenderer from '@/components/Cargo/Common/ColumnTagRenderer'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as CrmCustomerConstants from '@/class/cargo/model/parameters/CrmCustomerConstants'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { User } from '@/class/model/sys/User'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import { getSpecificBasicDataFromCache } from '@/utils/basicDataCache'
import { OPERATOR_IN } from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { getMyCustomerSelectType } from '@/api/basicData/customerRating'
import $store from '@/store'

export default {
  name: 'CustomerShareTreeGrid',
  components: {
    cargoUserSelect,
    CargoAdvanceSelect,
    CargoGridShowBigContent,
    searchItem
  },
  props: {
    modelType: { type: Number, required: true, default: 1 }, // 模块类型 0.我的客户  1.本组客户  2.客户公海  3.客户回收站
    showSourceType: { type: Boolean, required: false, default: true } // 是否显示客户来源
  },
  data() {
    return {
      ColumnUtils,
      CrmCustomerConstants,
      selectTypeNames: TYPE_NAMES,
      filter: {
        pageNum: 1,
        pageSize: 50
      },
      filterJson: {},
      isAdvancedQuery: false, // 是否为高级查询
      total: 0,
      selectedJob: null,
      gridParams: {},
      gridOptions: {
        frameworkComponents: {
          ColumnTagRenderer
        },
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.onGridRowSelected(event)
        },
        getRowStyle: (params) => {
          return {}
        },
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        },
        onRowClicked: this.onRowClicked,
        onRowDoubleClicked: event => { this.toLook(event.data) }
      },
      columnDefs: [ // 显示列
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ClientNo'),
          field: 'clientId',
          colId: 'clientId',
          cellRenderer: (params) => {
            if (!params.value) return '0'
            return params.value.toString()
          },
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_ChineseName'),
          field: 'name',
          colId: 'name',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_EnglishName'),
          field: 'englishName',
          colId: 'englishName',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_BranchCompany'),
          field: 'branchId',
          colId: 'branchId',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'code')
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_ScaleOfCompanyEmployees'),
          field: 'companySize',
          colId: 'companySize',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return params.value.toString()
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_RegisteredCapitalIn10Thousand'),
          field: 'registeredCapital',
          colId: 'registeredCapital',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return params.value.toString()
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CreatedDate'),
          field: 'dateCreated',
          colId: 'dateCreated',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_ClientStatus'),
          field: 'customerStatusCode',
          colId: 'customerStatusCode',
          cellRendererSelector: (params) => {
            const render = {
              component: 'ColumnTagRenderer'
            }
            const { customerStatusCode } = params.data
            render.params = {
              color: this.tagColor[customerStatusCode],
              value: ColumnUtils.customerStatusCodeToColumnLabelFun(customerStatusCode)
            }
            return render
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_AssessedClientLevel'),
          field: 'customerLevelCode',
          colId: 'customerLevelCode',
          hide: true,
          width: 200,
          cellRenderer: (params) => {
            if (!params.value) params.value = '0'
            const code = this.customerSelectTypes.customerLevelCode.find(item => parseInt(item.code) === parseInt(params.value))
            return !code ? '' : $store.getters.language === 'zh' ? code.chineseName : code.englishName
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_DifficultyIndex'),
          field: 'overcomeLevelCode',
          colId: 'overcomeLevelCode',
          hide: true,
          width: 200,
          cellRenderer: (params) => {
            if (!params.value) params.value = '0'
            const code = this.customerSelectTypes.overcomeLevelCode.find(item => parseInt(item.code) === parseInt(params.value))
            return !code ? '' : $store.getters.language === 'zh' ? code.chineseName : code.englishName
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomerContactChannel'),
          field: 'customerContactChannel',
          colId: 'customerContactChannel',
          hide: true,
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.customerContactChannelLabelFun(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomerType'),
          field: 'companyTypeCode',
          colId: 'companyTypeCode',
          cellRenderer: (params) => {
            return ColumnUtils.companyTypeCodeToColumnLabelFun(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_SourceOfClient'),
          field: 'sourceType',
          colId: 'sourceType',
          hide: !this.showSourceType,
          cellRenderer: (params) => {
            return ColumnUtils.sourceTypeCodeToColumnLabelFun(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_FirstContactDate'),
          field: 'firstMeetDate',
          colId: 'firstMeetDate',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Competitor'),
          field: 'competitorCompany',
          colId: 'competitorCompany',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Sales'),
          field: 'ownerId',
          colId: 'ownerId',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_30DaysShpt'),
          field: 'freightVolume30',
          colId: 'freightVolume30',
          cellRenderer: (params) => {
            if (!params.value) return '0'
            return params.value.toString()
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_60DaysShpt'),
          field: 'freightVolume60',
          colId: 'freightVolume60',
          cellRenderer: (params) => {
            if (!params.value) return '0'
            return params.value.toString()
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_90DaysShpt'),
          field: 'freightVolume90',
          colId: 'freightVolume90',
          cellRenderer: (params) => {
            if (!params.value) return '0'
            return params.value.toString()
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Over90DaysShpt'),
          field: 'freightVolumeGt90',
          colId: 'freightVolumeGt90',
          cellRenderer: (params) => {
            if (!params.value) return '0'
            return params.value.toString()
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_DaysNotFollowedUp'),
          field: 'unAskDays',
          colId: 'unAskDays',
          hide: true,
          cellRenderer: (params) => {
            if (!params.value) return '0'
            return ColumnUtils.formatUnAskDays(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_PreferredShippingRoute'),
          field: 'airlineCode',
          colId: 'airlineCode',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.likeAirlineCode(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_PreferredPort'),
          field: 'seaPortCode',
          colId: 'seaPortCode',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.likeSeaPortCode(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_PreferredAirport'),
          field: 'airPortCode',
          colId: 'airPortCode',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.likeAirPortCode(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remarks',
          colId: 'remarks',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Country'),
          field: 'country',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', params.value, this.isZh ? 'chineseName' : 'name')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Abbreviation'),
          field: 'shortName',
          width: 150,
          hide: true
        }
      ],
      rowData: [],
      gridApi: null,
      conditions: [],
      customerStatusCode: -1,
      potentialCount: 0,
      contemplationCount: 0,
      businessCount: 0,
      cooperationCount: 0,
      allCustomerCount: 0,
      tagColor: {
        0: '#8DCE64', // 潜在阶段
        1: '#00A795', // 意向阶段
        2: '#00A6F4', // 商务阶段
        3: '#5469BA' // 合作阶段
      },
      customerAssignWindow: { // 分配
        visible: false,
        sales: '',
        type: 0, // 0 分配 1、直接分配
        selectedItems: []
      },
      customerSelectTypes: {
        customerLevelCode: [],
        overcomeLevelCode: [],
        loaded: false
      }
    }
  },
  computed: {
    customSearchItems() { // 自定义高级查询项
      return this.getCustomSearchItems()
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  created() {
    this.conditions = []
  },
  methods: {
    async loadCustomerSelectTypes() {
      if (this.customerSelectTypes.loaded) return
      try {
        const res = await getMyCustomerSelectType()
        if (res.code === '0') {
          this.customerSelectTypes.customerLevelCode = res.data.customerLevelList || []
          this.customerSelectTypes.overcomeLevelCode = res.data.difficultyList || []
          this.customerSelectTypes.loaded = true
        }
      } catch (error) {
        console.error('获取客户选择类型失败:', error)
      }
    },
    // 组装查询条件
    getCustomSearchItems() {
      const defaultSearchFields = []
      // 销售
      let searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'user'
      searchField.subType = {
        category: 'role',
        shape: 'sales',
        officeId: null
      }
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_USER'
      searchField.itemName = 'quotationClient.OWNER_ID'
      searchField.itemLabel = 'CargoMsg.Cargo_Sales'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.dataCacheKey = ''
      searchField.lock = false
      searchField.defaultValue = ''
      defaultSearchFields.push(searchField.formatObj2Json())

      // 客户类型 CARGO-25396 客户类型、客户接触渠道改为基础数据维护
      let crmCustomerTypeList = CrmCustomerConstants.CUSTOMER_TYPE
      crmCustomerTypeList = crmCustomerTypeList.concat(getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_CrmCustomerType))
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'quotationClient.COMPANY_TYPE_CODE'
      searchField.itemLabel = 'CargoMsg.Cargo_CustomerType'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = crmCustomerTypeList
      defaultSearchFields.push(searchField.formatObj2Json())

      // 即将到期天数
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'input'
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.subType = 'bigdecimalForPositive'
      searchField.precision = '0'
      searchField.fieldType = 'FIELD_NUMBER'
      searchField.itemName = 'quotationClient.DUE_TIME'
      searchField.itemLabel = 'CargoMsg.Cargo_DaysToContractExpiry'
      searchField.itemValue = undefined
      searchField.defaultSelected = this.modelType === 0 ? 1 : 0
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.dataCacheKey = ''
      searchField.lock = false
      searchField.defaultValue = undefined
      defaultSearchFields.push(searchField.formatObj2Json())

      // 未跟进天数
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'input'
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.subType = 'bigdecimalForPositive'
      searchField.precision = '0'
      searchField.fieldType = 'FIELD_NUMBER'
      searchField.itemName = 'quotationClient.UN_ASK_DAYS'
      searchField.itemLabel = 'CargoMsg.Cargo_DaysNotFollowedUp'
      searchField.itemValue = undefined
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.dataCacheKey = ''
      searchField.lock = false
      searchField.defaultValue = undefined
      defaultSearchFields.push(searchField.formatObj2Json())

      // 所属城市
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'countryAreaCascader'
      searchField.itemCondition = [OPERATOR_IN]
      searchField.defaultConditionVal = OPERATOR_IN.code
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemName = 'quotationClient.PROVINCE'
      searchField.itemLabel = 'CargoMsg.Cargo_City'
      searchField.defaultValue = []
      defaultSearchFields.push(searchField.formatObj2Json())

      // CARGO-45606 CRM模块中，增加合作伙伴简称字段
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'input'
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemName = 'quotationClient.SHORT_NAME'
      searchField.itemLabel = 'CargoMsg.Cargo_Abbreviation'
      searchField.defaultValue = []
      defaultSearchFields.push(searchField.formatObj2Json())

      // 获取客户评定等级，及攻克难度指数数据
      this.loadCustomerSelectTypes()
      // 客户评定等级
      const customerLevelCode = this.customerSelectTypes.customerLevelCode
      // 攻克难度指数
      const overcomeLevelCode = this.customerSelectTypes.overcomeLevelCode
      if (customerLevelCode && customerLevelCode.length > 0) {
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.UPDATE_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 0
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
        searchField.itemName = 'quotationClient.CUSTOMER_LEVEL_CODE'
        searchField.itemLabel = 'CargoMsg.Cargo_AssessedClientLevel'
        searchField.itemValue = []
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = customerLevelCode
        defaultSearchFields.push(searchField.formatObj2Json())
      }

      if (overcomeLevelCode && overcomeLevelCode.length > 0) {
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.UPDATE_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 0
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
        searchField.itemName = 'quotationClient.OVERCOME_LEVEL_CODE'
        searchField.itemLabel = 'CargoMsg.Cargo_DifficultyIndex'
        searchField.itemValue = []
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = overcomeLevelCode
        defaultSearchFields.push(searchField.formatObj2Json())
      }

      let customerContactChannelList = CrmCustomerConstants.CUSTOMER_CONTACT_CHANNEL_GRID
      customerContactChannelList = customerContactChannelList.concat(getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_CustomerContactChannel))
      if (customerContactChannelList && customerContactChannelList.length > 0) {
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.UPDATE_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 0
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
        searchField.itemName = 'quotationClient.CUSTOMER_CONTACT_CHANNEL'
        searchField.itemLabel = 'CargoMsg.Cargo_CustomerContactChannel'
        searchField.itemValue = []
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = customerContactChannelList
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      return defaultSearchFields
    },
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    async onGridCellFocused(event) {
      if (!event) return
      this.selectedJob = null
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.gridApi)
        if (this.gridApi && event.column) {
          this.gridApi.forEachNode(node => {
            if (node && node.rowIndex === event.rowIndex && node.data) {
              const nodeJob = node.data
              if (nodeJob.uuid) this.selectedJob = nodeJob
            }
          })
        }
      })
    },
    // 选中 勾选框触发[获取选中行]
    onGridRowSelected(event) {
      if (!event || !event.data) return
      this.selectedJob = null
      if (event.node.isSelected()) {
        const node = event.data
        if (node.uuid) this.selectedJob = node
      }
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.gridApi)
      })
    },
    onGridReady(p) {
      // console.log('gridReady', p)
      this.gridApi = p.api
    },
    // 行点击触发事件
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedJob = null
      const node = event.data
      if (node.uuid) this.selectedJob = node
    },
    // 查询
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 简单查询
    toSimpleQuery(keyword) {
      if (typeof keyword !== 'undefined') {
        this.filter.name = keyword.trim() // 中文名、英文名
        this.filter.pageNum = 1
      }

      const roleMap = {}
      roleMap.name = this.filter.name
      this.conditions = []
      // 销售为0
      this.conditions.push(new AdvancedSearchOption(null, 'quotationClient.OWNER_ID', 0).formatObj2Json())
      // 是否有效
      this.conditions.push(new AdvancedSearchOption(null, 'quotationClient.ACTIVE', 1).formatObj2Json())
      this.queryCommon(roleMap)
    },
    // 高级查询
    toAdvancedQuery(data) {
      if (data) this.conditions = data
      // 高级查询条件组装
      const roleMap = {}
      this.handConditions(roleMap, this.conditions)
      this.queryCommon(roleMap)
    },
    // 查询公用
    queryCommon(roleMap) {
      roleMap.modelType = this.modelType
      const requestBody = {
        conditions: this.conditions,
        roleMap,
        pageNum: this.filter.pageNum,
        pageSize: this.filter.pageSize,
        branchId: this.$store.getters.currentOfficeId
      }
      this.$logger.log('requestBody====', requestBody)
      // 相当于老cargo 的 queryQuotationClientPageableFast2
      this.loading = getLoading()
      queryQuotationClientPageable(requestBody).then(res => this.handleQueryData(res)).finally(() => {
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      this.rowData = res.data.list
      this.total = Number(res.data.total)
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      if (this.gridApi) this.gridApi.clearFocusedCell()
    },
    // 处理高级查询条件
    handConditions(roleMap, conditions) {
      // 客户分配状态 ASSIGN_DATE为分配日期 ASSIGN_DATE!=null 说明客户已分配
      if (AdvancedSearchOption.hasField('quotationClient.ASSIGN_DATE', conditions)) {
        const ownerIdOption = AdvancedSearchOption.getOption('quotationClient.ASSIGN_DATE', conditions)
        AdvancedSearchOption.removeOption('quotationClient.ASSIGN_DATE', conditions)
        if (ownerIdOption.value > -1) {
          // 已分配,.大于1
          if (ownerIdOption.value === 1) {
            ownerIdOption.operator = AdvancedSearchConsts.OPERATOR_IS_NOT_NULL.code
          } else {
            ownerIdOption.operator = AdvancedSearchConsts.OPERATOR_IS_NULL.code
          }
          conditions.push(ownerIdOption.formatObj2Json())
        }
      }
      // 没有销售跟进的客户池
      if (AdvancedSearchOption.hasField('quotationClient.OWNER_ID', conditions)) {
        const ownerIdOption = AdvancedSearchOption.getOption('quotationClient.OWNER_ID', conditions)
        if (ownerIdOption.value <= 0) {
          AdvancedSearchOption.removeOption('quotationClient.OWNER_ID', conditions)
        }
      }
      conditions.push(new AdvancedSearchOption(null, 'quotationClient.OWNER_ID', 0).formatObj2Json())

      // 是否有效
      if (!AdvancedSearchOption.hasField('quotationClient.ACTIVE', conditions)) {
        AdvancedSearchOption.removeOption('quotationClient.ACTIVE', conditions)
      }
      conditions.push(new AdvancedSearchOption(null, 'quotationClient.ACTIVE', 1).formatObj2Json())
      // 即将到期天数
      if (AdvancedSearchOption.hasField('quotationClient.DUE_TIME', conditions)) {
        const option = AdvancedSearchOption.removeOption('quotationClient.DUE_TIME', conditions)
        roleMap.dueTime = { 'value': option.value, 'operator': option.operator }
      }
      // 所属城市
      if (AdvancedSearchOption.hasField('quotationClient.PROVINCE', conditions)) {
        const option = AdvancedSearchOption.removeOption('quotationClient.PROVINCE', conditions)
        const countryArr = []
        const provinceArr = []
        const cityArr = []
        const districtsArr = []
        for (const item of option.value) {
          switch (item.length) {
            case 1:
              countryArr.push(item[0])
              break
            case 2:
              provinceArr.push(item[1])
              break
            case 3:
              cityArr.push(item[2])
              break
            case 4:
              districtsArr.push(item[3])
              break
          }
        }
        if (countryArr.length > 0) {
          conditions.push({ ...option, fieldName: 'quotationClient.COUNTRY', value: countryArr })
        }
        if (provinceArr.length > 0) {
          conditions.push({ ...option, fieldName: 'quotationClient.PROVINCE', value: provinceArr })
        }
        if (cityArr.length > 0) {
          conditions.push({ ...option, fieldName: 'quotationClient.CITY', value: cityArr })
        }
        if (districtsArr.length > 0) {
          conditions.push({ ...option, fieldName: 'quotationClient.DISTRICTS', value: districtsArr })
        }
      }
    },
    // 查看
    toLook(row) {
      if (!row) {
        row = this.selectedJob || this.readSelectedRows()[0]
      }
      row.customerStatusCode = this.customerStatusCode
      this.$emit('look', row)
    },
    // 获取选中行
    readSelectedRows(tips = true) {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0 && tips) {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
      return rows
    },
    // 刷新表格
    refreshAgGrid(runToQuery = false) {
      // 刷寻右边查询结果
      if (runToQuery) this.toQuery()
      this.gridApi.refreshCells({ force: true })
      this.gridApi.clearFocusedCell()
    },
    // 分配
    assignHandler() {
      this.assignCommonHandler(0)
    },
    // 直接分配
    directAssignHandler() {
      this.assignCommonHandler(1)
    },
    // 分配 直接分配公用
    assignCommonHandler(type) {
      const selectedItems = this.readSelectedRows(false)
      if (!selectedItems || selectedItems.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CustomerNotSelected'))
        return
      }
      this.customerAssignWindow.sales = ''
      this.customerAssignWindow.type = type
      this.customerAssignWindow.selectedItems = selectedItems
      this.customerAssignWindow.visible = true
    },
    // 确认分配
    enterAssignHandler() {
      if (!this.checkSales()) return
      this.loading = getLoading()
      const clientKeys = Array.from(this.customerAssignWindow.selectedItems, p => p.uuid)
      const conMap = {
        ownerId: this.customerAssignWindow.sales,
        sourceType: CrmCustomerConstants.SOURCE_TYPE_LEADER_ASSIGN.code
      }
      const requestBody = {
        conMap,
        clientKeys: clientKeys,
        branchId: this.$store.getters.currentOfficeId
      }
      // 分配
      if (this.customerAssignWindow.type === 0) {
        assignQuotationClientsAndApprove(requestBody).then(res => {
          this.assignResultHandler(res)
        }).finally(() => {
          this.customerAssignWindow.visible = false
          this.loading.close()
        })
        return
      }
      // 直接分配
      if (this.customerAssignWindow.type === 1) {
        assignQuotationClients(requestBody).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_AssignedClientsSuccessfully', [this.customerAssignWindow.selectedItems.length]))
          this.refreshAgGrid(true)
        }).finally(() => {
          this.customerAssignWindow.visible = false
          this.loading.close()
        })
      }
    },
    // 分配 及 分配给我 结果处理
    async assignResultHandler(event) {
      const item = event.data
      console.log('item==============', item)
      const sameList = item['same']
      const diffList = item['diff']
      let content = ''
      if (diffList.length > 0) {
        for (const q of diffList) {
          const chineseName = q.name ? q.name : this.$t('CargoMsg.Cargo_ChineseNameIsEmpty')
          let oldGroupLeader = ''
          const user = await User.getUserById(q.groupLeaderId)
          if (user) {
            oldGroupLeader = user.chineseName ? user.chineseName : this.$t('CargoMsg.Cargo_OriginalTeamLeaderIsEmpty')
          }
          content += this.$t('CargoMsg.Cargo_CustomerName') + '：' + chineseName + '<br>' + this.$t('CargoMsg.Cargo_FormerGroupLeader') + '：' + oldGroupLeader + '<br><br>'
        }
      }
      this.refreshAgGrid(true)
      if (sameList.length > 0 && diffList.length < 1) {
        await this.$confirm(this.$t('CargoMsg.Cargo_AssignedClientsSuccessfully', [sameList.length]), this.$t('CargoMsg.Cargo_Distribution'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          type: 'success'
        })
      } else if (diffList.length > 0 && sameList.length < 1) {
        const message = this.$t('CargoMsg.Cargo_AssignedClientsSuccessfully2', [diffList.length]) + '<br><br>' + diffList.length +
          this.$t('CargoMsg.Cargo_examine') + '：<br>'
        await this.$confirm(message + content, this.$t('CargoMsg.Cargo_Distribution'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          type: 'success'
        })
      } else if (sameList.length > 0 && diffList.length > 0) {
        const count = sameList.length + diffList.length
        const messageTwo = this.$t('CargoMsg.Cargo_AssignedClientsSuccessfully2', [count]) + '<br><br>' + sameList.length + this.$t('CargoMsg.Cargo_DistributionSales') + '<br><br>' + diffList.length + this.$t('CargoMsg.Cargo_examine') + '：<br>'
        await this.$confirm(messageTwo + content, this.$t('CargoMsg.Cargo_Distribution'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          type: 'success'
        })
      }
    },
    // 验证销售
    checkSales() {
      if (!this.customerAssignWindow.sales || parseInt(this.customerAssignWindow.sales) === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SalesNotSelected'))
        return false
      }
      return true
    },
    // 分配给我
    assignMyHandler() {
      const selectedItems = this.readSelectedRows(false)
      if (!selectedItems || selectedItems.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CustomerNotSelected'))
        return
      }
      const ownerId = this.$store.getters.userId// 销售即为当前用户
      // 校验上一次的销售跟当前销售是否一致，若一致进行则提示“禁止对当前客户进行操作，请联系销售经理解决！”
      let isSameSale = false
      for (const quotationClient of selectedItems) {
        if (quotationClient.preOwnerId && ownerId === parseInt(quotationClient.preOwnerId) && parseInt(quotationClient.preOwnerId) !== 0) {
          isSameSale = true
        }
      }
      if (isSameSale) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DoNotOperate'))
        return
      }
      this.loading = getLoading()
      const clientKeys = Array.from(selectedItems, p => p.uuid)
      const conMap = {
        ownerId: ownerId,
        sourceType: CrmCustomerConstants.SOURCE_TYPE_SALE_OBTAIN.code
      }
      const requestBody = {
        conMap,
        clientKeys: clientKeys,
        branchId: this.$store.getters.currentOfficeId
      }
      assignQuotationClientsAndApprove(requestBody).then(res => {
        this.assignResultHandler(res)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 删除
    deleteHandler() {
      const selectedItems = this.readSelectedRows(false)
      if (selectedItems && selectedItems.length > 1) {
        this.$message.warning(this.$t('common.tips.hasOneOnly'))
        return
      }
      if (!selectedItems[0]) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectForDelete'))
        return
      }
      this.loading = getLoading()
      const requestBody = {
        conMap: { clientKey: selectedItems[0].uuid },
        branchId: this.$store.getters.currentOfficeId
      }
      checkDeleteCustomer(requestBody).then(res => {
        const canBeDeleteStatus = res.data.canBeDeleteStatus
        if (canBeDeleteStatus === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_DeleteFailed'))
          return
        }
        if (canBeDeleteStatus === 2) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CannotBeDeleted'))
          return
        }
        if (canBeDeleteStatus === 1) {
          this.$confirm(this.$t('CargoMsg.Cargo_AreYouSureDelete'), this.$t('common.tips.confirm'), {
            confirmButtonText: this.$t('common.btn.yes'),
            cancelButtonText: this.$t('common.btn.no'),
            closeOnClickModal: false,
            type: 'info'
          }).then(() => {
            this.loading = getLoading()
            deleteCustomer(requestBody).then(res => {
              const result = res.data
              if (result === 1) {
                this.$message.success(this.$t('CargoMsg.Cargo_DeleteSuccessfully'))
                this.refreshAgGrid(true)
              }
            }).finally(() => {
              this.loading.close()
            })
          }).catch(() => { })
        }
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style lang="scss">
</style>
